import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addToCart, getCartDetails, getCartSummary, updateCart, deleteFromCart, checkout } from "../../api/cart.api";

export const useCheckout = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: checkout,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["cartDetails"] });
            queryClient.invalidateQueries({ queryKey: ["cartSummary"] });
            queryClient.invalidateQueries({ queryKey: ["quotationSummary"] });
            queryClient.invalidateQueries({ queryKey: ["quotationDetail"] });
            queryClient.invalidateQueries({ queryKey: ["products"] });
            queryClient.invalidateQueries({ queryKey: ["bestSellers"] });
            queryClient.invalidateQueries({ queryKey: ["productDetails"] });
            queryClient.invalidateQueries({ queryKey: ["search"] });
            queryClient.invalidateQueries({ queryKey: ["wishlist"] });
        },
    });
};

export const useAddToCart = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: addToCart,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["cartDetails"] });
            queryClient.invalidateQueries({ queryKey: ["cartSummary"] });
            queryClient.invalidateQueries({ queryKey: ["productDetails"] });
            queryClient.invalidateQueries({ queryKey: ["products"] });
            queryClient.invalidateQueries({ queryKey: ["bestSellers"] });
            queryClient.invalidateQueries({ queryKey: ["search"] });
            queryClient.invalidateQueries({ queryKey: ["wishlist"] });
        },
    });
};

export const useUpdateCart = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: updateCart,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["cartDetails"] });
            queryClient.invalidateQueries({ queryKey: ["cartSummary"] });
            queryClient.invalidateQueries({ queryKey: ["productDetails"] });
            queryClient.invalidateQueries({ queryKey: ["products"] });
            queryClient.invalidateQueries({ queryKey: ["bestSellers"] });
            queryClient.invalidateQueries({ queryKey: ["search"] });
            queryClient.invalidateQueries({ queryKey: ["wishlist"] });
        },
    });
};

export const useDeleteFromCart = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: deleteFromCart,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["cartDetails"] });
            queryClient.invalidateQueries({ queryKey: ["cartSummary"] });
            queryClient.invalidateQueries({ queryKey: ["productDetails"] });
            queryClient.invalidateQueries({ queryKey: ["products"] });
            queryClient.invalidateQueries({ queryKey: ["bestSellers"] });
            queryClient.invalidateQueries({ queryKey: ["search"] });
            queryClient.invalidateQueries({ queryKey: ["wishlist"] });
        },
    });
};

export const useCartDetails = () => {
    return useQuery({
        queryKey: ["cartDetails"],
        queryFn: getCartDetails,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};

export const useCartSummary = (options = {}) => {
    return useQuery({
        queryKey: ["cartSummary"],
        queryFn: getCartSummary,
        staleTime: 1000 * 60 * 5, // 5 minutes
        ...options
    });
};
